import React from 'react'

const BackgroundColor = ({ blok }) => {
    return (
            <div className={'background-color ' + blok.color} />
    )
}

export default BackgroundColor